import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';
import {
  IResNotificationsOK,
  Notifications,
} from '@/types/parcel/notifications/notifications.interface';

export interface NotificationProps {
  title: string;
  options: OptionProps[];
  onChgOption: (id: string, enabled: boolean) => void;
}

export interface OptionProps {
  description: string;
  id: string;
  enabled: boolean;
  type: string;
}

const useNotificationsConfig = () => {
  const [checked, setChecked] = useState(false);
  const [endClientType, setEndClientType] = useState<Notifications[]>([]);
  const [userType, setUserType] = useState<Notifications[]>([]);

  const handleToggle = () => {
    setChecked((prev) => !prev);
  };

  const fetchNotifications = async () => {
    const http = initializeHttpProvider();
    try {
      const response = await http.notifications.notifications();
      const data = (response as IResNotificationsOK).data;
      setEndClientType(data.notifications.filter((item) => item.type === 'endClient'));
      setUserType(data.notifications.filter((item) => item.type === 'user'));
    } catch (err) {
      console.error(err);
      toast.error('Error al cargar las notificaciones');
    }
  };

  const updateNotifications = async (id: string, enabled: boolean) => {
    const http = initializeHttpProvider();
    try {
      await http.notifications.updateNotification({ id, enabled }).then(async () => {
        await fetchNotifications();
        toast.success('Notificación actualizada');
      });
    } catch (err) {
      console.error(err);
      toast.error('Error al actualizar la notificación');
    }
  };

  useEffect(() => {
    void fetchNotifications();
  }, []);

  const notifications = [
    {
      title: 'Elige las notificaciones que desees recibir por correo electrónico:',
      options: userType,
    },
    {
      title: 'Elige las notificaciones que deseas que reciban tus clientes:',
      options: endClientType,
    },
  ];

  return {
    // functions
    handleToggle,

    // states
    checked,

    notifications,
    updateNotifications,
  };
};

export default useNotificationsConfig;
